export const PASSWORD_POLICY_ERROR =
    'Password must be 8-32 characters and include uppercase, lowercase, number, and special character.';

export const PASSWORD_POLICY_PATTERN =
    '^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,32}$';

const SPECIAL_CHARACTER_PATTERN = /[^A-Za-z0-9]/;

export function getPasswordPolicyError(password: string): string | null {
    if (
        password.length < 8 ||
        password.length > 32 ||
        !/[A-Z]/.test(password) ||
        !/[a-z]/.test(password) ||
        !/[0-9]/.test(password) ||
        !SPECIAL_CHARACTER_PATTERN.test(password)
    ) {
        return PASSWORD_POLICY_ERROR;
    }

    return null;
}

export function shouldEnforcePasswordPolicy(
    action: string | undefined,
): boolean {
    if (!action) {
        return false;
    }

    let pathname: string;
    try {
        pathname = new URL(
            action,
            globalThis.location?.origin ?? 'http://localhost',
        ).pathname;
    } catch {
        pathname = action;
    }

    return [
        '/self-service/registration',
        '/self-service/recovery',
        '/self-service/settings',
    ].some((prefix) => pathname.startsWith(prefix));
}
